import { render, staticRenderFns } from "./MemberTableByAllSro.vue?vue&type=template&id=a6f05070&scoped=true"
import script from "./MemberTableByAllSro.vue?vue&type=script&lang=js"
export * from "./MemberTableByAllSro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f05070",
  null
  
)

export default component.exports